module.exports = __webpack_public_path__ + "static/img/increase-lead-process.ac52f0b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/details-page/increase-lead-process.jpg
// module id = fl2d
// module chunks = 1